import React from 'react';
import './pose-detection-loading-modal.scss';

interface PoseDetectionLoadingModalProps {
  visible: boolean;
}

const PoseDetectionLoadingModal: React.FC<PoseDetectionLoadingModalProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="pose-detection-loading-modal">
      <div className="loading-content">
        <p className="loading-text">Initializing pose detection...</p>
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
      </div>
    </div>
  );
};

export default PoseDetectionLoadingModal;